import { BaseModel } from "./base";
import { Transportadora } from "./transportadora";
import { Veiculo } from "./veiculo";

export default class MarcaModelo extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public createdAt: Date,
    public updatedAt: Date,
    public veiculos: Veiculo[]
  ) {
    super(id);
  }
}
